import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "../../utils";
import icons from '../../resources/icons';
import DetailsHandlerDef from "../../details/DetailsHandlerDef";
export default Class(DetailsHandlerDef, {
  initialize: function initialize(options) {
    this.options = options ? options : {};
    this.isMore = true;
    if (this.options.more) this.isMore = true;
    var myOptions = {
      buttonText: "Plandokument",
      buttonImage: icons.searchers.planer.result,
      handler: this.myHandler,
      isApplicable: function isApplicable(result) {
        return result.source === "Plansystem" && result.type === "Vedtaget lokalplan";
      },
      more: this.isMore
    };
    DetailsHandlerDef.prototype.initialize.apply(this, [myOptions]);
  },
  myHandler: function () {
    var _myHandler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var items, planId, url, planNr, _url;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];
              items.push({
                type: 'link',
                icon: icons.details.link,
                link: result.data.properties.doklink,
                linkTitle: "Se plandokument i Plansystem"
              });

              if (this.options.odeumClientName) {
                planId = result.data.properties.planid;
                url = 'http://plandk2.mapcentia.com/apps/custom/planurl/public/index.php/api/v1/url/' + this.options.odeumClientName + '/lokalplaner.lpplandk2_join/' + planId;
                items.push({
                  type: 'link',
                  icon: icons.details.link,
                  link: url,
                  linkTitle: "Se plandokument i ODEUM (Du viderestilles til Plansystem.dk, hvis Odeum ikke har lokalplanen)"
                });
              }

              if (this.options.dkplanName) {
                planNr = result.data.properties.plannr;
                _url = 'http://' + this.options.dkplanName + '.viewer.dkplan.niras.dk/dkplan/dkplan.aspx?LokalplanNr=' + planNr;
                items.push({
                  type: 'link',
                  icon: icons.details.link,
                  link: _url,
                  linkTitle: "Se plandokument i DKPlan"
                });
              }

              return _context.abrupt("return", items);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function myHandler(_x) {
      return _myHandler.apply(this, arguments);
    }

    return myHandler;
  }(),
  CLASS_NAME: 'Septima.Search.DokLinksForLokalplan'
});